export const GET_PRODUCTS_REQUEST = "GET/PRODUCTS/REQUEST";
export const GET_PRODUCTS_SUCCESS = "GET/PRODUCTS/SUCCESS";
export const GET_PRODUCTS_ERROR = "GET/PRODUCTS/ERROR";

export const LoginSuccess = "LoginSuccess";
export const LogoutSuccess = "LogoutSuccess";

export const GET_TOTAL_PRODUCTS_REQUEST = "GET/TOTAL/PRODUCTS/REQUEST";
export const GET_TOTAL_PRODUCTS_SUCCESS = "GET/TOTAL/PRODUCTS/SUCCESS";
export const GET_TOTAL_PRODUCTS_ERROR = "GET/TOTAL/PRODUCTS/ERROR";

export const POST_ADDTOCART_REQUEST = "POST/ADDTOCART/REQUEST";
export const POST_ADDTOCART_SUCCESS = "POST/ADDTOCART/SUCCESS";
export const POST_ADDTOCART_ERROR = "POST/ADDTOCART/ERROR";

export const SET_CART_TOTALS = "SET_CART_TOTALS";
export const SET_CART_DATA = "SET_CART_DATA";



export const POST_WISHLIST_REQUEST = "POST/WISHLIST/REQUEST";
export const POST_WISHLIST_SUCCESS = "POST/WISHLIST/SUCCESS";
export const POST_WISHLIST_ERROR = "POST/WISHLIST/ERROR";
